import { selectorFamily, atomFamily } from 'recoil';
import { elementSelector } from '../elements/selectors.js';

var initPoiSelector = selectorFamily({
    key: "initPointSelector",
    get: function (_a) {
        var elementId = _a.elementId;
        return function (_a) {
            var _b, _c;
            var get = _a.get;
            var element = get(elementSelector(elementId));
            return { x: ((_b = element === null || element === void 0 ? void 0 : element.pointOfInterest) === null || _b === void 0 ? void 0 : _b.x) || 50, y: ((_c = element === null || element === void 0 ? void 0 : element.pointOfInterest) === null || _c === void 0 ? void 0 : _c.y) || 50 };
        };
    }
});
var thumbnailGeneratorPoiState = atomFamily({
    key: "thumbnailGeneratorPoiState",
    "default": initPoiSelector
});

export { thumbnailGeneratorPoiState };
//# sourceMappingURL=atoms.js.map
